import { render } from "./FkList.vue?vue&type=template&id=b9214ff4"
import script from "./FkList.vue?vue&type=script&lang=js"
export * from "./FkList.vue?vue&type=script&lang=js"

import "./FkList.vue?vue&type=style&index=0&id=b9214ff4&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__